'use strict'

const bodyEl = document.querySelector('body'); 

const state = () => {
	return bodyEl.dataset.interactive; 
}

export default state; 